// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__MoPIU","tab":"Tabs_tab__PJkHS","isActive":"Tabs_isActive__Z9Zx4"};